import React from 'react';
import styled from 'styled-components';

const MainContainer = styled.main`
  padding-top: 0;
`;

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  background-color: white;
  z-index: 1000;
  padding: 0;
  border-bottom: 1px solid #eaeaea;
  height: 42px;
  display: flex;
  align-items: center;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  width: 100%;
`;

const Logo = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  
  color: #5E3FBF;
`;

const Nav = styled.nav`
  display: flex;
  gap: 1.5rem;
  font-size: 0.8rem;
  align-items: center;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: #333;
  text-decoration: none;
  padding: 0;
  font-size: 0.8rem;
  
  &:hover {
    color: #5E3FBF;
  }
`;

const HeroSection = styled.section`
  max-width: 1200px;
  margin: 3.5rem auto 2rem;
  padding: 0 1rem;
  text-align: center;
`;

const HeroTitle = styled.h1`
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 0.8rem;
  font-weight: 600;
`;

const HeroDescription = styled.p`
  font-size: 0.9rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto 3rem;
`;

const FeaturesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  max-width: 1200px;
  margin: 0 auto 4rem;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background-color: #f8f9fa;
  padding: 2rem 1.5rem;
  text-align: center;
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FeatureIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5E3FBF;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  
  img {
    width: 100%;
    height: auto;
  }
`;

const FeatureTitle = styled.h3`
  color: #333;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const FeatureDescription = styled.p`
  color: #666;
  font-size: 0.85rem;
  line-height: 1.5;
`;

const AboutSection = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  max-width: 1200px;
  margin: 2rem auto 5rem;
  padding: 0 1rem;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AboutContent = styled.div``;

const AboutTitle = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const AboutDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.2rem;
  font-size: 0.95rem;
`;

const AboutImage = styled.div`
  img {
    width: 100%;
    border-radius: 0.5rem;
  }
`;

const ContactSection = styled.section`
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 1rem;
  text-align: center;
`;

const ContactTitle = styled.h2`
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 0.8rem;
  font-weight: 600;
`;

const ContactSubtitle = styled.p`
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 2.5rem;
`;

const ContactCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContactCard = styled.div`
  background-color: #f8f9fa;
  padding: 2rem 1.5rem;
  text-align: center;
  border-radius: 0.25rem;
`;

const ContactIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: #5E3FBF;
`;

const ContactType = styled.h3`
  font-size: 1rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const ContactInfo = styled.p`
  font-size: 0.85rem;
  color: #666;
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  font-size: 0.8rem;
  color: #666;
`;

const HomePage = () => {
  return (
    <MainContainer>
      <HeaderContainer>
        <Header>
          <Logo>Connect Financial Associates</Logo>
          <Nav>
            <NavLink href="#product">Services</NavLink>
            <NavLink href="#about">About Us</NavLink>
            <NavLink href="#contact">Contact</NavLink>
          </Nav>
        </Header>
      </HeaderContainer>

      <div id="product"></div>
      <HeroSection>
        <HeroTitle>Technology Planning Services</HeroTitle>
        <HeroDescription>
          Plan your ideal financial services technology stack
        </HeroDescription>
      </HeroSection>

      <FeaturesContainer>
        <FeatureCard>
          <FeatureIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#5E3FBF" strokeWidth="2" />
            </svg>
          </FeatureIcon>
          <FeatureTitle>Simple</FeatureTitle>
          <FeatureDescription>
            We make complicated decisions simple
          </FeatureDescription>
        </FeatureCard>
        
        <FeatureCard>
          <FeatureIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" stroke="#5E3FBF" strokeWidth="2" fill="none" />
              <path d="M12 6V12L16 14" stroke="#5E3FBF" strokeWidth="2" stroke-linecap="round" />
            </svg>
          </FeatureIcon>
          <FeatureTitle>Experienced</FeatureTitle>
          <FeatureDescription>
            We have decades of experience and know what works
          </FeatureDescription>
        </FeatureCard>
        
        <FeatureCard>
          <FeatureIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="#5E3FBF" strokeWidth="2" fill="none"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="#5E3FBF" strokeWidth="2" fill="none"/>
            </svg>
          </FeatureIcon>
          <FeatureTitle>Integrated</FeatureTitle>
          <FeatureDescription>
            We help you plan a fully integrated architecture
          </FeatureDescription>
        </FeatureCard>
      </FeaturesContainer>

      <div id="about"></div>
      <AboutSection>
        <AboutContent>
          <AboutTitle>About Us</AboutTitle>
          <AboutDescription>
            We're a team of passionate individuals dedicated to helping financial institutions navigate the complexity of modern technology. Our journey began with a simple idea: to make technology more understandable.
          </AboutDescription>
          <AboutDescription>
            Our team has decades of experience serving the credit union industry.
          </AboutDescription>
        </AboutContent>
        <AboutImage>
          <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80" alt="Our team at work" />
        </AboutImage>
      </AboutSection>

      <div id="contact"></div>
      <ContactSection>
        <ContactTitle>Contact Us</ContactTitle>
        <ContactSubtitle>Get in touch with our team</ContactSubtitle>
        
        <ContactCards>
          <ContactCard>
            <ContactIcon>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#5E3FBF" strokeWidth="2" />
                <polyline points="22,6 12,13 2,6" stroke="#5E3FBF" strokeWidth="2" />
              </svg>
            </ContactIcon>
            <ContactType>Email</ContactType>
            <ContactInfo>contact@connectfa.info</ContactInfo>
          </ContactCard>
          
          <ContactCard>
            <ContactIcon>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="#5E3FBF" strokeWidth="2" />
              </svg>
            </ContactIcon>
            <ContactType>Phone</ContactType>
            <ContactInfo>801-327-8701</ContactInfo>
          </ContactCard>
          
          <ContactCard>
            <ContactIcon>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="10" r="3" stroke="#5E3FBF" strokeWidth="2" />
                <path d="M12 21c-3.87 0-7-3.13-7-7 0-3.87 3.13-7 7-7s7 3.13 7 7c0 1.5-.47 2.87-1.28 4L12 21v-7" stroke="#5E3FBF" strokeWidth="2" />
              </svg>
            </ContactIcon>
            <ContactType>Location</ContactType>
            <ContactInfo>Sandy, UT</ContactInfo>
          </ContactCard>
        </ContactCards>
      </ContactSection>
      
      <Footer>
        © 2025 Connect Financial Associates
      </Footer>
    </MainContainer>
  );
};

export default HomePage;
